export const enum SupportChatCodeVerifyStatus {
    Verified = 0,
    Invalid = 1,
    Expired = 2,
    TooManyAttempts = 3,
    NoCode = 4
}
